export interface Sorting {
  orderBy: "asc" | "desc";
  selector: string;
}

export const defaultSorting: Sorting = {
  orderBy: "desc",
  selector: "creationDate",
};
